"use client";
import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			preserveAspectRatio='xMidYMid slice'
			fill='none'
			id='people'
			width='186'
			viewBox='0 0 186 186'>
			<path
				className={fillHover}
				d='M51.233 93.856c.156-7.788 6.544-14.174 14.33-14.174 2.806 0 5.452.779 7.634 2.18.934-3.426 3.115-6.387 5.92-8.411-1.247-1.403-2.805-2.494-4.517-3.116-2.494 2.025-5.61 3.27-9.037 3.27-3.425 0-6.54-1.245-9.034-3.27-3.116 1.246-5.607 3.738-6.853 7.01 1.09 2.025 1.557 4.204 1.557 6.698 0 3.115-.935 5.92-2.648 8.41.934.313 1.713.78 2.648 1.403z'></path>
			<mask
				id='mask0_220_535'
				style={{ maskType: "luminance" }}
				width='23'
				height='22'
				x='54'
				y='48'
				maskUnits='userSpaceOnUse'>
				<path
					className={fillHover}
					d='M54.56 48.372h21.824v21.564H54.56V48.372z'></path>
			</mask>
			<g mask='url(#mask0_220_535)'>
				<path
					className={fillHover}
					d='M65.563 69.868c5.921 0 10.75-4.83 10.75-10.75 0-5.918-4.829-10.746-10.75-10.746-5.919 0-10.747 4.828-10.747 10.747s4.828 10.75 10.747 10.75z'></path>
			</g>
			<path
				className={fillHover}
				d='M112.762 82.018c2.182-1.403 4.829-2.181 7.634-2.181 7.787 0 14.33 6.386 14.33 14.174a15.545 15.545 0 012.648-1.712c-1.712-2.337-2.648-5.298-2.648-8.413 0-2.337.624-4.673 1.558-6.698-1.246-3.115-3.738-5.762-6.853-7.01-2.494 2.027-5.609 3.273-9.035 3.273-3.427 0-6.543-1.246-9.036-3.273a15.57 15.57 0 00-4.517 3.116c2.804 2.336 4.985 5.297 5.919 8.724z'></path>
			<mask
				id='mask1_220_535'
				style={{ maskType: "luminance" }}
				width='23'
				height='22'
				x='109'
				y='48'
				maskUnits='userSpaceOnUse'>
				<path
					className={fillHover}
					d='M109.616 48.372h21.824v21.564h-21.824V48.372z'></path>
			</mask>
			<g mask='url(#mask1_220_535)'>
				<path
					className={fillHover}
					d='M120.397 69.868c5.919 0 10.747-4.83 10.747-10.75 0-5.918-4.828-10.746-10.747-10.746-5.921 0-10.75 4.828-10.75 10.747.155 5.919 4.986 10.75 10.75 10.75z'></path>
			</g>
			<path
				className={fillHover}
				d='M79.895 94.011c0 .936-.155 1.87-.312 2.804 2.024-5.45 7.322-9.344 13.396-9.344 6.076 0 11.373 3.894 13.397 9.344-.157-.934-.312-1.868-.312-2.803 0-3.583 1.403-6.853 3.428-9.347-.624-4.516-3.583-8.256-7.634-9.813-2.492 2.026-5.607 3.272-9.034 3.272-3.428 0-6.543-1.246-9.035-3.115-4.05 1.557-7.01 5.295-7.632 9.813 2.335 2.337 3.738 5.607 3.738 9.19zM92.979 74.385c5.92 0 10.749-4.829 10.749-10.748s-4.828-10.75-10.75-10.75c-5.918 0-10.747 4.831-10.747 10.75 0 6.074 4.829 10.748 10.748 10.748zM53.103 102.891c-1.09-3.582-3.74-6.386-7.167-7.789-2.491 2.025-5.607 3.27-9.034 3.27-3.428 0-6.541-1.245-9.035-3.27-4.05 1.713-7.165 5.452-7.632 9.971l-1.247 10.123c-.155 1.403.778 2.649 2.026 2.806a74.278 74.278 0 0015.888 1.712c2.648 0 5.297-.155 7.788-.312l.467-4.516c.624-5.297 3.74-9.658 7.946-11.995zM36.902 94.635c5.919 0 10.749-4.828 10.749-10.749 0-5.92-4.83-10.747-10.75-10.747-5.919 0-10.747 4.828-10.747 10.747 0 5.921 4.829 10.75 10.748 10.75zM166.97 115.196l-1.246-10.123c-.467-4.674-3.582-8.413-7.632-9.97-2.493 2.024-5.609 3.27-9.034 3.27-3.428 0-6.543-1.246-9.035-3.27-3.427 1.402-6.076 4.206-7.167 7.788 4.207 2.492 7.322 6.853 7.946 11.995l.467 4.516c2.492.312 5.14.312 7.789.312 5.607 0 10.904-.624 15.887-1.712 1.248-.157 2.182-1.403 2.025-2.806zM149.058 94.635c5.919 0 10.747-4.828 10.747-10.749 0-5.92-4.828-10.747-10.747-10.747s-10.749 4.828-10.749 10.747c0 5.921 4.83 10.75 10.749 10.75zM80.674 110.523c-1.403-2.492-3.583-4.362-6.075-5.295-2.493 2.024-5.609 3.27-9.036 3.27-3.425 0-6.541-1.246-9.035-3.27-4.049 1.712-7.164 5.452-7.631 9.968l-1.246 10.125c-.157 1.246.622 2.494 2.024 2.804a75.213 75.213 0 0015.888 1.715c2.182 0 4.206-.157 6.388-.312l.779-6.853c.622-5.297 3.582-9.659 7.944-12.152zM65.563 83.419c-5.919 0-10.747 4.83-10.747 10.75 0 5.918 4.828 10.747 10.747 10.747 5.921 0 10.75-4.829 10.75-10.748-.156-5.919-4.986-10.75-10.75-10.75zM137.063 115.196c-.622-4.673-3.583-8.411-7.632-9.968-2.494 2.024-5.609 3.27-9.035 3.27-3.427 0-6.543-1.246-9.036-3.27-2.647 1.09-4.672 2.958-6.074 5.295 4.206 2.493 7.321 6.855 7.943 11.995l.779 7.01c2.025.155 4.207.312 6.388.312 5.607 0 10.903-.624 15.888-1.715 1.246-.31 2.181-1.558 2.024-2.804l-1.245-10.125zM120.396 83.419c-5.921 0-10.749 4.83-10.749 10.75 0 5.918 4.828 10.747 10.749 10.747 5.919 0 10.748-4.829 10.748-10.748s-4.829-10.75-10.748-10.75z'></path>
			<mask
				id='mask2_220_535'
				style={{ maskType: "luminance" }}
				width='38'
				height='26'
				x='74'
				y='112'
				maskUnits='userSpaceOnUse'>
				<path
					className={fillHover}
					d='M74.896 112.592h36.208v25.06H74.896v-25.06z'></path>
			</mask>
			<g mask='url(#mask2_220_535)'>
				<path
					className={fillHover}
					d='M109.647 122.985c-.624-4.673-3.583-8.411-7.632-9.969-2.494 2.025-5.61 3.271-9.037 3.271-3.425 0-6.54-1.246-9.034-3.271-4.05 1.713-7.165 5.452-7.632 9.969l-1.246 10.125c-.157 1.246.622 2.494 2.025 2.804a75.214 75.214 0 0015.888 1.714c5.609 0 10.904-.623 15.889-1.714 1.246-.31 2.182-1.558 2.025-2.804l-1.246-10.125z'></path>
			</g>
			<path
				className={fillHover}
				d='M92.979 91.208c-5.92 0-10.748 4.828-10.748 10.749 0 5.919 4.829 10.747 10.748 10.747 5.92 0 10.749-4.828 10.749-10.747 0-5.921-4.828-10.75-10.75-10.75z'></path>
		</svg>
	);
}

export default Icon;
